export default Object.freeze([
	{
		id: 3,
		tallerID: 7,
		name: 'Carlos Joseph Gutiérrez Sánchez',
		shortName: 'Güero',
		order: 1,
	},
	{
		id: 7,
		tallerID: 8,
		name: 'Hugo Pozos',
		shortName: 'Hugo',
		order: 2,
	},
	{
		id: 26,
		tallerID: 18,
		name: 'Daniel Hernández',
		shortName: 'Dany',
		order: 3,
	},
	{
		id: 33,
		tallerID: 27,
		name: 'Juan Carlos Fernandez Martinez',
		shortName: 'Carlos',
		order: 4,
	},
	{
		id: 50,
		tallerID: 42,
		name: 'Carlos Uriel Corona García',
		shortName: 'Charly',
		order: 5,
	},
	{
		id: 54,
		tallerID: 43,
		name: 'Joshua Josué Mercader Tamayo',
		shortName: 'Joshua',
		order: 6,
	},
	{
		id: 63,
		tallerID: 50,
		name: 'José Enrique Mora Licona',
		shortName: 'Enrique',
		order: 7,
	},
	{
		id: 99,
		tallerID: 51,
		name: 'Alexis Gabriel Becerril  Carmona',
		shortName: 'Gabriel',
		order: 8,
	},
	{
		id: 999,
		tallerID: 53,
		name: 'Asistente Chalco',
		shortName: 'Asistente Chalco',
		order: 89,
	},
])
